export interface ISessionMeetingStatus {
  readonly message: string
  readonly pendencies: string[]
  readonly profile: string
  readonly status: string
  readonly type: string
}